import { Link } from 'react-router-dom';

const newArticleImages: string[] = [
  'https://readdy.ai/api/search-image?query=Premium%20sneakers%20elegantly%20displayed%20on%20minimal%20cream%20surface%20with%20soft%20natural%20light%20casting%20gentle%20shadows%20clean%20product%20photography%20warm%20neutral%20tones%20editorial%20aesthetic%20modern%20fashion&width=600&height=450&seq=card-sneakers-v2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Organized%20workspace%20with%20laptop%20showing%20data%20tables%20surrounded%20by%20neatly%20arranged%20fashion%20accessories%20bags%20and%20small%20decor%20items%20on%20warm%20wooden%20desk%20soft%20natural%20daylight%20cream%20and%20beige%20tones&width=600&height=450&seq=card-cssbuy-v2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Modern%20shopping%20tablet%20displaying%20product%20grid%20surrounded%20by%20beautifully%20arranged%20electronics%20gadgets%20and%20small%20fashion%20pieces%20on%20clean%20marble%20surface%20warm%20natural%20lighting%20soft%20shadows%20minimal%20style&width=600&height=450&seq=card-superbuy-v2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20of%20unique%20trendy%20fashion%20pieces%20and%20quirky%20accessories%20scattered%20artistically%20on%20soft%20pastel%20pink%20and%20cream%20surface%20creative%20composition%20dreamy%20editorial%20photography&width=600&height=450&seq=card-oopbuy-v2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Split%20screen%20concept%20with%20two%20elegant%20product%20displays%20side%20by%20side%20on%20minimal%20neutral%20background%20warm%20cream%20and%20soft%20beige%20tones%20clean%20editorial%20style%20professional%20comparison%20aesthetic&width=600&height=450&seq=card-kvscss-v2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Two%20stylish%20product%20collections%20displayed%20in%20parallel%20on%20warm%20minimal%20surface%20one%20side%20fashion%20items%20other%20electronics%20soft%20natural%20light%20clean%20editorial%20composition%20cream%20and%20sand%20tones&width=600&height=450&seq=card-kvssuper-v2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Contrasting%20shopping%20concept%20with%20mainstream%20fashion%20on%20one%20side%20and%20unique%20artisanal%20pieces%20on%20the%20other%20displayed%20on%20clean%20warm%20surface%20soft%20natural%20lighting%20editorial%20photography%20blush%20and%20cream%20tones&width=600&height=450&seq=card-kvsoop-v2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Treasure%20hunt%20concept%20with%20beautiful%20curated%20products%20partially%20revealed%20from%20elegant%20minimal%20boxes%20on%20warm%20neutral%20surface%20soft%20natural%20light%20cream%20and%20sand%20tones%20editorial%20photography&width=600&height=450&seq=card-findsdb-v2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Secure%20shopping%20concept%20with%20shield%20symbol%20and%20carefully%20arranged%20luxury%20products%20on%20clean%20minimal%20surface%20soft%20natural%20daylight%20warm%20cream%20and%20sage%20green%20tones%20editorial%20photography%20sense%20of%20trust&width=600&height=450&seq=card-safety-v2&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Elegant%20fashion%20flat%20lay%20with%20beautifully%20folded%20designer%20inspired%20clothing%20pieces%20accessories%20scarves%20and%20jewelry%20artistically%20arranged%20on%20warm%20cream%20surface%20soft%20natural%20light%20editorial%20photography%20minimal%20aesthetic&width=600&height=450&seq=card-fashion-v2&orientation=landscape',
];

const newPosts = [
  {
    title: 'Kakobuy Spreadsheet for Sneakers: The Ultimate 2026 Buying Guide',
    excerpt: 'Discover how to use the Kakobuy Spreadsheet to find the best sneaker deals, compare prices across platforms, and avoid counterfeit products.',
    date: 'July 8, 2026',
    category: 'Category Guides',
    slug: '/kakobuy-spreadsheet-sneakers',
  },
  {
    title: 'CSSBuy Spreadsheet Guide: How to Find the Best Products in 2026',
    excerpt: 'A comprehensive guide to using CSSBuy Spreadsheets for product discovery across all major categories.',
    date: 'July 8, 2026',
    category: 'Platform Guides',
    slug: '/cssbuy-spreadsheet-guide',
  },
  {
    title: 'Kakobuy vs CSSBuy Spreadsheet: Comprehensive 2026 Comparison',
    excerpt: 'In-depth head-to-head comparison of Kakobuy and CSSBuy spreadsheets across product variety, update frequency, and verification standards.',
    date: 'July 6, 2026',
    category: 'Comparisons',
    slug: '/kakobuy-vs-cssbuy',
  },
  {
    title: 'Kakobuy vs Superbuy Spreadsheet: Which Platform Wins in 2026?',
    excerpt: 'Compare Kakobuy and Superbuy spreadsheets across product selection, pricing, shipping, and community quality.',
    date: 'July 6, 2026',
    category: 'Comparisons',
    slug: '/kakobuy-vs-superbuy',
  },
  {
    title: 'Kakobuy Finds Database: How to Discover Hidden Product Gems',
    excerpt: 'Master advanced search techniques, filtering strategies, and community tips to uncover hidden gems before they go mainstream.',
    date: 'July 5, 2026',
    category: 'Shopping Guides',
    slug: '/kakobuy-finds-database',
  },
  {
    title: 'Kakobuy Spreadsheet Safety Guide: Shop Without Risks',
    excerpt: 'Learn to identify scams, verify sellers, avoid counterfeit products, and protect your personal data while shopping.',
    date: 'July 4, 2026',
    category: 'Safety',
    slug: '/kakobuy-safety-guide',
  },
];

export default function ContentGrid() {
  return (
    <section id="guides" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full border border-background-300/60 text-foreground-600 text-xs font-semibold uppercase tracking-wider mb-4">
            Latest Guides
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            Latest Spreadsheet
            <br />
            Guides &amp; Reviews
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {newPosts.map((post, idx) => (
            <Link
              key={post.slug}
              to={post.slug}
              className="group block rounded-2xl border border-background-200/70 bg-background-50 hover:border-primary-200 transition-all duration-300 overflow-hidden cursor-pointer"
            >
              <div className="aspect-[4/3] bg-background-100 flex items-center justify-center p-8 relative overflow-hidden">
                <img
                  src={newArticleImages[idx]}
                  alt={post.title}
                  className="w-full h-full object-cover rounded-xl"
                  loading="lazy"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-[11px] text-foreground-500">{post.date}</span>
                  <span className="inline-block px-2.5 py-0.5 rounded-full bg-accent-100 text-accent-800 text-[10px] font-semibold uppercase">
                    {post.category}
                  </span>
                </div>
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors">
                  {post.title}
                </h3>
                <p className="mt-2 text-foreground-600 text-xs md:text-sm leading-relaxed line-clamp-2">
                  {post.excerpt}
                </p>
                <span className="inline-flex items-center gap-1.5 mt-4 text-primary-600 text-sm font-semibold group-hover:gap-2.5 transition-all">
                  Read Article
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}